import { render, staticRenderFns } from "./TwoStepVerification.vue?vue&type=template&id=ebce96e4&scoped=true"
import script from "./TwoStepVerification.vue?vue&type=script&lang=js"
export * from "./TwoStepVerification.vue?vue&type=script&lang=js"
import style0 from "./TwoStepVerification.vue?vue&type=style&index=0&id=ebce96e4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebce96e4",
  null
  
)

export default component.exports